<template>
    <div>
    <section class="research-friend-links" v-if="links.length">
        <div class="friend-links-title"><span><i>↗</i><b>友情链接</b><small>RESEARCH NETWORK</small></span></div>
        <div class="friend-links-list">
            <a v-for="(item,index) in links" :key="index" :href="linkHref(item.url)" target="_blank" rel="noopener noreferrer"><i></i>{{item.name}}</a>
        </div>
    </section>
    <div class='fxwidth' id="footer_nav">
        <router-link :class="item.url === $route.path?'active':''" v-for="(item,index) in footerList" :key="index" :to="item.url">
            <i :class="'icon'+index"><em v-if="index === 4 && notice>0"></em></i>
            <span>{{item.name}}</span>
        </router-link>
    </div>

    </div>
</template>

<script>
export default {
    name: "Footer",
    data(){
        return {
            notice: 0, //this.$store.state.notice,
            links: [],
            footerList: [
                {
                    id: 1,
                    name: '首页',
                    url: '/'
                },
                {
                    id: 2,
                    name: '推荐',
                    url: '/recommend'
                },
                {
                    id: 3,
                    name: '专家',
                    url: '/rank'
                },
                {
                    id: 3,
                    name: '数据',
                    url: '/bifen'
                },
                {
                    id: 4,
                    name: '我的',
                    url: '/my'
                },
            ]
        }
    },
    created() {
        this.getLinks()
        this.getNotice()
    },
    methods: {
        linkHref(url){
            const value=String(url||'').trim()
            if(/^https?:\/\//i.test(value))return value
            if(/^\/\//.test(value))return 'https:'+value
            return value?'https://'+value:'#'
        },
        getLinks(){
            this.$post(this.$api.home,{footer:1}).then(res=>{
                if(res&&res.code===1)this.links=(res.data.links||[]).filter(item=>item&&item.name&&item.url)
            }).catch(()=>{this.links=[]})
        },
        getNotice(){
            let that = this
            setInterval(function () {
                let notice = 0
                if (that.$store.state.token != null) {
                    that.$post(that.$api.getnotice).then(function (res) {
                        // console.log(res)
                        if (res.code === 1) {
                            // console.log(notice)
                            notice = res.data.notice_count
                        }
                        that.$store.commit('SET_NOTICE', notice)
                        that.notice = notice
                    })
                }
                else{
                    that.$store.commit('SET_NOTICE', notice)
                    that.notice = notice
                }
            }, 1000 * 60 * 2)
        }
    }
}
</script>

<style scoped>
</style>
